import React from 'react'
import Slider from 'react-slick'
import MovieItem from '../MovieItem'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const PrevArrow = ({onClick, testId, ...rest}) => (
  <button
    {...rest}
    type="button"
    onClick={onClick}
    data-testid={`${testId}PreviousBtn`}
    aria-label="previous"
  >
    &#10094;
  </button>
)

const NextArrow = ({onClick, testId, ...rest}) => (
  <button
    {...rest}
    type="button"
    onClick={onClick}
    data-testid={`${testId}NextBtn`}
    aria-label="next"
  >
    &#10095;
  </button>
)

const MoviesSlider = ({moviesList, testId}) => {
  const settings = {
    dots: false,
    infinite: true, // <-- allow wrapping so prev/next always changes slides
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow testId={testId} />,
    nextArrow: <NextArrow testId={testId} />,
    responsive: [
      {breakpoint: 768, settings: {slidesToShow: 2}},
      {breakpoint: 480, settings: {slidesToShow: 1}},
    ],
  }

  return (
    <div className="movies-slider-container" data-testid={testId}>
      <Slider {...settings}>
        {moviesList.map(movie => (
          <MovieItem key={movie.id} movieDetails={movie} />
        ))}
      </Slider>
    </div>
  )
}

export default MoviesSlider
